import {createStore} from 'vuex'
import getters from './getters';
import createPersistedState from 'vuex-persistedstate';
import table from "./modules/table";
import pagination from "./modules/pagination";
import { PAGE_SIZE_STORAGE_KEY, normalizePageSize } from '@/utils/pageSize.mjs';

const store = createStore({
    plugins: [
        createPersistedState({
            // SECURITY: 白名单模式，只持久化非敏感的 UI 状态
            // token / userInfo / mobile 等敏感字段不会被写入 localStorage
            paths: ['table.lang'],
            storage: window.localStorage
        })
    ],
    modules: {
        table,
        pagination
    },
    getters
})

if (typeof window !== 'undefined') {
    window.addEventListener('storage', (event) => {
        if (event.key !== PAGE_SIZE_STORAGE_KEY) {
            return;
        }
        store.commit('SYNC_PAGE_SIZE_FROM_STORAGE', normalizePageSize(event.newValue));
    });
}

export default store
